module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "intended-user-edit-dialog",
    attrs: {
      "close-on-click-modal": false,
      "title": "合同状态"
    },
    on: {
      "close": function($event) {
        _vm.closeCallBack()
      }
    },
    model: {
      value: (_vm.visiable1),
      callback: function($$v) {
        _vm.visiable1 = $$v
      },
      expression: "visiable1"
    }
  }, [_vm._l((_vm.htList), function(item) {
    return _c('el-form', {
      ref: "dynamicValidateForm",
      refInFor: true,
      staticClass: "demo-dynamic",
      attrs: {
        "label-width": "120px"
      }
    }, [_c('div', [_c('h4', [_vm._v("合同状态：" + _vm._s(item.ContractStatusName))]), _vm._v(" "), _c('el-row', [_c('el-col', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isShowByStatus2(item.ContractNumber)),
        expression: "isShowByStatus2(item.ContractNumber)"
      }],
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "合同号"
      }
    }, [_c('span', [_vm._v(_vm._s(item.ContractNumber))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "状态"
      }
    }, [_c('span', [_vm._v(_vm._s(item.ContractStatusName))])])], 1)], 1), _vm._v(" "), _c('el-row', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isShowByStatus2(item.Consignee)),
        expression: "isShowByStatus2(item.Consignee)"
      }]
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "收件人"
      }
    }, [_c('span', [_vm._v(_vm._s(item.Consignee))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "收件人电话"
      }
    }, [_c('span', [_vm._v(_vm._s(item.ConsigneeTel))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "收件地址"
      }
    }, [_c('span', [_vm._v(_vm._s(item.ConsigneeAdress))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "物流或快递单号"
      }
    }, [_c('span', [_vm._v(_vm._s(item.LogisticsCode))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      staticClass: "edit-form",
      attrs: {
        "label": "物流或快递名称"
      }
    }, [_c('span', [_vm._v(_vm._s(item.LogisticsName))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.getTimeStr(item.ContractStatusName)
      }
    }, [_c('span', [_vm._v(_vm._s(item.ConsigneeTime))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "备注"
      }
    }, [_c('span', [_vm._v(_vm._s(item.Remark))])])], 1)], 1)], 1), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), (_vm.htList.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "16px",
      "height": "30px",
      ",line-height": "30px",
      "margin-top": "30px"
    }
  }, [_vm._v("暂无合同状态!")]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visiable1 = false;
      }
    }
  }, [_vm._v("关 闭")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f8fc5c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMFormatAgent/components/viewContractStatusListDialog/index.vue
// module id = 1465
// module chunks = 1